import axios from "./index";

class PlanesPagoApi {
  static fetchPlanesPago = () => {
    return axios.get(`/procesos/planespago/`);
  };
  static fetchPlanesPagoSoft = () => {
    return axios.get(`/procesos/planespago/soft/`);
  };
  static fetchPlanesPagoPaginacion = (params = {}) => {
    return axios.get(`/procesos/planespago/paginacion/`, { params });
  };
  static obtenerPlanPagoById = (planpagoId) => {
    return axios.get(`/procesos/planespago/${planpagoId}`);
  };
  static obtenerPlanPagoByProcesoIdentificador = (procesoIdentificador) => {
    return axios.get(`/procesos/planespago/${procesoIdentificador}/consultar/`);
  };
  static registrarPlanPago = (data) => {
    return axios.post(`/procesos/planespago/registrar/`, data);
  };
  static operarPlanPago = (data) => {
    return axios.post(`/procesos/planespago/operarPlanPago/`, data);
  };
  static actualizarPlanPago = (planpagoId, data) => {
    return axios.put(`/procesos/planespago/${planpagoId}/actualizar/`, data);
  };
  static eliminarPlanPago = (planpagoId) => {
    return axios.delete(`/procesos/planespago/${planpagoId}/eliminar/`);
  };
  static fetchMovimientos = (planPagoId) => {
    //alert("fetchMovimientos.planPagoId: " + planPagoId);
    return axios.get(`/procesos/movimientos/${planPagoId}`);
  };
  static obtenerIngresoGastoById = (ingrGastId) => {
    return axios.get(`/procesos/movimientos/${ingrGastId}`);
  };
  static registrarIngresoGasto = (data) => {
    return axios.post(`/procesos/movimientos/registrar/`, data);
  };
  static actualizarIngresoGasto = (ingrGastId, data) => {
    return axios.put(`/procesos/movimientos/${ingrGastId}/actualizar/`, data);
  };
  static eliminarIngresoGasto = (ingrGastId) => {
    return axios.delete(`/procesos/movimientos/${ingrGastId}/eliminar/`);
  };
}

export default PlanesPagoApi;
